import en from './en-GB.json';
import sv from './sv-SE.json';
import nb from './nb-NO.json';

const translations = {
  'en-GB': en,
  'sv-SE': sv,
  'nb-NO': nb,
};

export default translations;
